const createAction = (type, payload = null) => ({ type, payload })

export default createAction
